import { Zap } from 'lucide-react'
import { AppLayout } from './layout/AppLayout'
import { UserMenu } from './layout/UserMenu'

// Deliberately thin — no sidebar, no module nav — since a homeowner only ever has one thing to
// see (their own home). TailAdmin header, same shared UserMenu as the Rabbit Console.
export function EnergyOSDashboardLayout() {
  return (
    <AppLayout
      brand={{ name: 'EnergyOS', icon: Zap }}
      homeTo="/energy-os/dashboard"
      sections={null}
      mainClassName="max-w-4xl"
      headerRight={<UserMenu />}
    />
  )
}
